export const ICONS = [
  'accessories.svg',
  'accomodation.svg',
  'beach.svg',
  'beer.svg',
  'bike.svg',
  'boat.svg',
  'boat2.svg',
  'book.svg',
  'book1.svg',
  'breakfast.svg',
  'calendar.svg',
  'camera.svg',
  'car.svg',
  'car2.svg',
  'castle.svg',
  'churchNight.svg',
  'cloud.svg',
  'drone.svg',
  'euro.svg',
  'flower.svg',
  'food.svg',
  'forest.svg',
  'goPro.svg',
  'hike.svg',
  'history.svg',
  'info.svg',
  'jacuzzi.svg',
  'lake.svg',
  'marker.svg',
  'market.svg',
  'monument.svg',
  'museum.svg',
  'museum1.svg',
  'leaf.svg',
  'lens.svg',
  'observation.svg',
  'palmTree.svg',
  'parking.svg',
  'picnic.svg',
  'plane.svg',
  'sdCard.svg',
  'search.svg',
  'shopping.svg',
  'stars.svg',
  'stay.svg',
  'sun.svg',
  'tent.svg',
  'tickets.svg',
  'train.svg',
  'villa.svg',
  'village.svg',
  'virus.svg',
  'wine.svg',
];
